module.exports = __webpack_public_path__ + "media/img/corporate/logos/porsche-fe607772cfcd850aabcc7725a6a03465.svg";